var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar",
    {
      staticClass: "app-navbar white",
      attrs: { app: "", "clipped-left": _vm.clipped, height: "70" }
    },
    [
      _c("v-toolbar-side-icon", {
        staticClass: "btn-mini-variant",
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.$store.commit("layout/toggleMiniVariant")
          }
        }
      }),
      _vm._v(" "),
      _c("v-toolbar-side-icon", {
        staticClass: "btn-drawer",
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.$store.commit("layout/toggleDrawer")
          }
        }
      }),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c("app-lang"),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-fullscreen",
              attrs: { slot: "activator", icon: "" },
              on: {
                click: function($event) {
                  return _vm.fullscreen()
                }
              },
              slot: "activator"
            },
            [
              _c("v-icon", [_vm._v("fullscreen")]),
              _vm._v(" "),
              _c("v-icon", [_vm._v("fullscreen_exit")])
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Pantalla completa")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { slot: "activator", icon: "" },
              on: { click: _vm.reload },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Actualizar la página")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$store.commit("layout/toggleRightDrawer")
            }
          }
        },
        [_c("v-icon", [_vm._v("notifications")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "offset-x": "",
            "close-on-content-click": false,
            "max-width": "320",
            "min-width": "320"
          }
        },
        [
          _c(
            "v-toolbar-title",
            { attrs: { slot: "activator" }, slot: "activator" },
            [
              _c("v-avatar", { staticClass: "info" }, [
                _c("span", { staticClass: "white--text headline" }, [
                  _vm._v(_vm._s(_vm.inicial))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { staticClass: "menu-person", attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.nombreCompleto))]),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("mail")]),
                          _vm._v(" " + _vm._s(_vm.user.email)),
                          _c("br"),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("home")]),
                          _vm._v(" " + _vm._s(_vm.unidad)),
                          _c("br"),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("face")]),
                          _vm._v(" " + _vm._s(_vm.cargo)),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.user.roles, function(rol) {
                            return _c(
                              "span",
                              { key: rol.id },
                              [
                                _c("v-icon", [_vm._v("person_pin")]),
                                _vm._v(" " + _vm._s(rol.descripcion) + " "),
                                _c("br")
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$router.push("account")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-tile-title",
                        [
                          _c("v-icon", [_vm._v("account_circle")]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("app.account")) + "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { on: { click: _vm.logout } },
                    [
                      _c(
                        "v-list-tile-title",
                        [
                          _c("v-icon", [_vm._v("")]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("app.logOut")) + "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62a6eea7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a6eea7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppNavbar.vue
// module id = null
// module chunks = 